<template>
  <div class="public-content admin-maintenance">
    <div class="breadcrumb">系统菜单</div>
    <div class="add-category">
      <el-button round type="primary" v-permission="'crm:admin:menu:add'" @click="addMenu('top')">添加</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table row-key="id" :data="menuList" :cell-class-name='left' :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" border style="width: 100%">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="name" class="asd" label="名称" min-width="180"></el-table-column>
          <el-table-column label="图标">
            <template v-slot="scope">
              <i :class="scope.row.icon"></i>
            </template>
          </el-table-column>
          <el-table-column prop="component" label="地址" min-width="200"></el-table-column>
          <el-table-column prop="perms" label="权限标识" min-width="200"></el-table-column>
          <el-table-column label="操作" min-width="180">
            <template v-slot="scope">
              <span class="color-blue" v-if="$hasPermission('crm:admin:menu:add') && scope.row.type !== 'button'" style="margin-right: 5px" @click="addMenu('', scope.row)">添加</span>
              <span class="color-blue" v-if="$hasPermission('crm:admin:menu:update') && scope.row.pid !== 0" style="margin-right: 5px" @click="changeMenu(0, scope.row)">编辑</span>
              <span class="color-blue" @click="deleteMenu(scope.row)" v-if="$hasPermission('crm:admin:menu:removeMenu')">删除</span>
              <p v-show="scope.row.showSpecialBtn && $hasPermission('crm:admin:menu:special')" class="color-blue" @click="updateSpecial(scope.row)">{{ scope.row.isSpecial === 0 ? '设为特殊权限' : '取消特殊权限'
              }} </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 删除确认弹窗 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delteeMenu">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加编辑菜单 -->
    <el-dialog :close-on-click-modal="false" :title="title" @closed="closed" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="上级菜单:">
          <el-input v-model="form.pname" readonly clearable></el-input>
        </el-form-item>
        <el-form-item label="菜单类型:" prop="type">
          <el-radio v-model="form.type" :disabled='disabled' label="contents">目录</el-radio>
          <el-radio v-model="form.type" :disabled='disabled' label="menu">菜单</el-radio>
          <el-radio v-model="form.type" label="button">按钮</el-radio>
        </el-form-item>
        <el-form-item label="菜单名称:" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="链接地址:" prop="component">
          <el-input v-model="form.component" clearable></el-input>
        </el-form-item>
        <el-form-item label="权限标识:">
          <el-input v-model="form.perms" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序号:">
          <el-input v-model="form.sorting" clearable></el-input>
        </el-form-item>
        <el-form-item label="图标:">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div class="recharge-ok">选择图标</div>
          </div>
          <div v-if="form.icon" style="margin-top: 10px;">
            <img :src="form.icon" alt="">
          </div>
          <!-- <el-button round type="primary">选择图标</el-button> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeMenuInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getAllMenu, menuUpdate, menuAddMenu, getMenuById, menuRemoveMenu, menuUpdateSpecial } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'

export default {
  name: 'admin-maintenance',
  data () {
    return {
      disabled: false,
      deleteDialog: false,
      menuList: [],
      dialogVisible: false,
      title: '添加菜单',
      form: {},
      lock: false,
      rules: {
        type: [
          { required: true, message: '请选择菜单类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请填写菜单名称', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getAllMenu()
  },
  methods: {
    upload (e) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        loading.close()
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        loading.close()
        return
      }
      var file = e.target.files[0]
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.form.icon = res
        this.$forceUpdate()
        console.log(this.form.icon, 'this.form.icon')
        loading.close()
      })
    },
    updateSpecial (row) {
      console.log(row)
      menuUpdateSpecial({
        menuId: row.id,
        isSpecial: ~row.isSpecial + 2
      })
        .then(res => {
          if (res.data.success) {
            this.$message.success('已成功设置')
            row.isSpecial = ~row.isSpecial + 2
          }
        })
    },
    closed () {
      this.$refs.form.resetFields()
    },
    left ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return 'left'
      }
    },
    delteeMenu () {
      menuRemoveMenu(this.deleteId).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.deleteDialog = false
          this.getAllMenu()
        }
      })
    },
    changeMenuInfo () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.lock) { this.$message.warning('正在处理，请稍后'); return }
        if (this.title === '编辑菜单') {
          this.lock = true
          menuUpdate(this.form).then((res) => {
            this.lock = false
            if (res.data.success) {
              this.$message.success('编辑成功')
              this.getAllMenu()
              this.dialogVisible = false
            }
          })
        }
        if (this.title === '添加菜单') {
          this.lock = true
          menuAddMenu(this.form).then((res) => {
            this.lock = false
            if (res.data.success) {
              this.$message.success('添加成功')
              this.getAllMenu()
              this.dialogVisible = false
            }
          })
        }
      })
    },
    getAllMenu () {
      getAllMenu().then((res) => {
        if (res.data.success) {
          this.menuList = res.data.data
          // this.menuList.forEach(item => {
          //   if (item.id === 3) {
          //     this.addShowSpecialBtn(item.children)
          // })
          console.log(this.menuList)
          console.log(this.menuList.find(item => item.id === 2))
          this.addShowSpecialBtn(this.menuList.find(item => item.id === 2).children)
        }
      })
    },
    addShowSpecialBtn (list) {
      list.forEach(item => {
        item.showSpecialBtn = true
        if (item.children.length !== 0 && item.level !== 3) this.addShowSpecialBtn(item.children)
      })
    },
    addMenu (type, row) {
      this.disabled = false
      if (type === 'top') {
        this.form = {
          pname: '全部菜单',
          component: '',
          name: '',
          perms: '',
          pid: 0,
          sorting: '',
          type: '',
          url: ''
        }
      } else if (type === '') {
        if (row.level === 3) {
          this.form = {
            pname: row.name,
            component: '',
            name: '',
            perms: '',
            pid: row.id,
            sorting: '',
            type: 'button',
            url: ''
          }
          this.disabled = true
        } else {
          this.form = {
            pname: row.name,
            component: '',
            name: '',
            perms: '',
            pid: row.id,
            sorting: '',
            type: '',
            url: ''
          }
        }
      }
      this.title = '添加菜单'
      this.dialogVisible = true
    },
    changeMenu (item, row) {
      this.disabled = false
      this.title = '编辑菜单'
      getMenuById(row.pid).then((res) => {
        if (res.data.success) {
          if (row.level === 4) {
            this.disabled = true
          }
          this.form = {
            name: row.name,
            perms: row.perms,
            pname: res.data.data.name,
            sorting: row.sorting,
            type: row.type,
            component: row.component,
            icon: row.icon,
            id: row.id
          }
          this.dialogVisible = true
        }
      })
    },
    deleteMenu (content) {
      this.deleteId = content.id
      this.deleteDialog = true
    },
    deleteMenuOK () {
      this.getAllMenu()
    },
    addMenuOK () {
      this.getAllMenu()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

// @{deep} .el-table__row .el-table_1_column_2 .cell{
//   text-align: left!important;;
// }
@{deep} .left .cell {
  text-align: left !important;
}

.recharge-ok {
  border: 1px solid #3078FF;
  background: #3078FF;
  color: #fff;
}
</style>
